import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const PremiumSIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M7.46002 5.72003L16.54 5.60003V13.0246H18.18V4.08008H5.82001V19.8401H13.1882V18.2001H7.46002V5.72003ZM17.34 14.5247C15.8722 14.5247 14.6823 15.7146 14.6823 17.1824C14.6823 18.1575 15.2132 19.0009 15.9962 19.4633V22.5801L17.3273 21.5967L18.6585 22.5801V19.4771C19.4551 19.0182 19.9977 18.1678 19.9977 17.1824C19.9977 15.7146 18.8078 14.5247 17.34 14.5247L17.34 14.5247ZM17.34 18.4001C16.6686 18.4001 16.1223 17.8538 16.1223 17.1824C16.1223 16.5109 16.6686 15.9647 17.34 15.9647C18.0114 15.9647 18.5577 16.5109 18.5577 17.1824C18.5577 17.8538 18.0114 18.4001 17.34 18.4001ZM14.7247 7.64008H9.27527V9.08008H14.7247V7.64008Z"
      />
    </SvgIcon>
  );
});
